<div class="gm-game">
  <div class="gm-game-bar">
    <span class="gm-game-title">2048</span>
    <div class="gm-game-actions">
      <span class="gm-stat">Score <b>{{ score() }}</b></span>
      <button class="gm-btn" (click)="reset()">New</button>
    </div>
  </div>
  <div class="gm-game-body">
    <div
      #box
      class="tf-wrap"
      tabindex="0"
      (keydown)="onKey($event)"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
    >
      <div class="tf-grid">
        @for (v of grid(); track $index) {
          <div class="tf-cell">
            @if (v) {
              <span
                class="tf-tile"
                [style.background]="tileColor(v)[0]"
                [style.color]="tileColor(v)[1]"
                [style.fontSize.px]="tileFontSize(v)"
              >{{ v }}</span>
            }
          </div>
        }
      </div>
      @if (over() || won()) {
        <div class="tf-overlay">
          <div class="tf-msg">{{ over() ? 'Game over' : 'You hit 2048! 🎉' }}</div>
          <button class="gm-btn primary" (click)="reset()">{{ over() ? 'Try again' : 'Keep going / restart' }}</button>
        </div>
      }
    </div>
    <div class="tf-hint">Use arrow keys or swipe</div>
  </div>
</div>
